import React from 'react';

const CheckboxField = ({ name, checked, onChange, error, required = false, children }) => {
  const handleChange = (e) => {
    onChange(name, e.target.checked);
  };

  return (
    <div className="space-y-1">
      <label className="flex items-start space-x-3 cursor-pointer">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handleChange}
          className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
        />
        <span className="text-sm text-gray-700 leading-relaxed">
          {children}
          {required && <span className="text-red-500 ml-1">*</span>}
        </span>
      </label>
      {error && (
        <p className="text-red-500 text-sm ml-7">{error}</p>
      )}
    </div>
  );
};

export default CheckboxField;